import React, { Component } from 'react';
import { connect } from 'react-redux';
import { show } from 'redux-modal';
import get from 'lodash/get';
import moment from 'moment';
import { DateRange } from '../../../components/common';
import { SspApi } from '../../../api';
import Popup from './Popup';

class Dashboard extends Component {

  state = { startDate: moment().format(), end_date: moment().format(), chosenLabel: 'Today' }
  
  componentDidMount() {
    this.showPopup();
    this.fetchStats();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.website.uuid !== this.props.website.uuid) {
      this.showPopup();
      this.fetchStats();
    }
  }

  showPopup() {
    const { dispatch, website } = this.props;
    if (website.uuid && website.pixel_status === 'pixel_inactive') {
      dispatch(show('PixelPopModal', {}));  
    }
  }

  fetchStats() {
    const { website, dispatch } = this.props;
    if (website.uuid) {
      dispatch(SspApi.actions.websiteStats.get(website.uuid));
    }
  }

   handleDateApply(d) {
    this.setState({ 
      startDate: d.startDate.format(), 
      endDate: d.endDate.format(), 
      chosenLabel: d.chosenLabel 
    });
  }

  render() {
    const { website, websiteStats } = this.props;

    const ranges = {
      Today: [moment(), moment()],
      'Last 7 Days': [moment().subtract(6, 'days'), moment()],
      'Last 30 Days': [moment().subtract(29, 'days'), moment()],
      'This Month': [moment().startOf('month'), moment().endOf('month')],
      'Last Month': [
        moment().subtract(1, 'month').startOf('month'), 
        moment().subtract(1, 'month').endOf('month')
      ]
    };

    return (
        <div>
          <div className="row">
            <div className="col-xs-12">
              <DateRange
                key={`daterange-${website.uuid}`} 
                defaultChosenLabel='Today'
                opens='left' 
                startDate={moment(this.state.startDate)} 
                endDate={moment(this.state.endDate)} 
                ranges={ranges} 
                onApply={this.handleDateApply.bind(this)}
              />
            </div>
          </div>

          <h4>General Stats</h4>
          <div className="row">
            <div className="col-md-4 col-lg-3"><div className="ibox">
              <div className="ibox-title">
              <span className="label label-success pull-right">Total</span>
              <h5>Active Jobs</h5></div>
              <div className="ibox-content"><h1>{get(websiteStats, 'general.active_jobs', 0)}</h1></div>
            </div></div>
            <div className="col-md-4 col-lg-3"><div className="ibox">
              <div className="ibox-title">
              <span className="label label-success pull-right">Total</span>
              <h5>Active Feeds</h5></div>
              <div className="ibox-content"><h1>{get(websiteStats, 'general.active_feeds', 0)}</h1></div>
            </div></div>
             <div className="col-md-4 col-lg-3"><div className="ibox">
              <div className="ibox-title">
              <span className="label label-primary pull-right">{this.state.chosenLabel}</span>
              <h5>Jobs Indexed</h5></div>
              <div className="ibox-content"><h1>{get(websiteStats, 'general.indexed_jobs', 0)}</h1></div>
            </div></div>
            <div className="col-md-4 col-lg-3"><div className="ibox">
              <div className="ibox-title">
              <span className="label label-primary pull-right">{this.state.chosenLabel}</span>
              <h5>Visitors</h5></div>
              <div className="ibox-content"><h1>{get(websiteStats, 'general.visitors', 0)}</h1></div>
            </div></div>
            <div className="col-md-4 col-lg-3"><div className="ibox">
              <div className="ibox-title">
              <span className="label label-primary pull-right">{this.state.chosenLabel}</span>
              <h5>Requests</h5></div>
              <div className="ibox-content"><h1>{get(websiteStats, 'general.requests', 0)}</h1></div>
            </div></div>
            <div className="col-md-4 col-lg-3"><div className="ibox">
              <div className="ibox-title">
              <span className="label label-primary pull-right">{this.state.chosenLabel}</span>
              <h5>Search Keywords</h5></div>
              <div className="ibox-content"><h1>{get(websiteStats, 'general.keywords', 0)}</h1></div>
            </div></div>
            <div className="col-md-4 col-lg-3"><div className="ibox">
              <div className="ibox-title">
              <span className="label label-primary pull-right">{this.state.chosenLabel}</span>
              <h5>Search Locations</h5></div>
              <div className="ibox-content"><h1>{get(websiteStats, 'general.locations', 0)}</h1></div>
            </div></div>
            <div className="col-md-4 col-lg-3"><div className="ibox">
              <div className="ibox-title">
              <span className="label label-primary pull-right">{this.state.chosenLabel}</span>
              <h5>Total Earnings</h5></div>
              <div className="ibox-content"><h1>{get(websiteStats, 'general.earnings', 0)}</h1></div>
            </div></div>
          </div>
          
          <h4>Feed Stats</h4>
          
          <div className="row">
            <div className="col-md-4 col-lg-3"><div className="ibox">
              <div className="ibox-title">
              <span className="label label-primary pull-right">{this.state.chosenLabel}</span>
              <h5>Feed Clicks</h5></div>
              <div className="ibox-content"><h1>{get(websiteStats, 'feed.clicks', 0)}</h1></div>
            </div></div>
            <div className="col-md-4 col-lg-3"><div className="ibox">
              <div className="ibox-title">
              <span className="label label-primary pull-right">{this.state.chosenLabel}</span>
              <h5>Feed Impressions</h5></div>
              <div className="ibox-content"><h1>{get(websiteStats, 'feed.impressions', 0)}</h1></div>
            </div></div>
            <div className="col-md-4 col-lg-3"><div className="ibox">
              <div className="ibox-title">
              <span className="label label-primary pull-right">{this.state.chosenLabel}</span>
              <h5>Feed ACPC</h5></div>
              <div className="ibox-content"><h1>{get(websiteStats, 'feed.cpc', 0)}</h1></div>
            </div></div>
            <div className="col-md-4 col-lg-3"><div className="ibox">
              <div className="ibox-title">
              <span className="label label-primary pull-right">{this.state.chosenLabel}</span>
              <h5>Feed Earnings</h5></div>
              <div className="ibox-content"><h1>{get(websiteStats, 'feed.earnings', 0)}</h1></div>
            </div></div>
          </div>

          <h4>Ad Stats</h4>

          <div className="row">
            <div className="col-md-4 col-lg-3"><div className="ibox">
              <div className="ibox-title">
              <span className="label label-success pull-right">Total</span>
              <h5>Active Ad Slots</h5></div>
              <div className="ibox-content"><h1>{get(websiteStats, 'ad.slots', 0)}</h1></div>
            </div></div>
            <div className="col-md-4 col-lg-3"><div className="ibox">
              <div className="ibox-title">
              <span className="label label-primary pull-right">{this.state.chosenLabel}</span>
              <h5>Ad Clicks</h5></div>
              <div className="ibox-content"><h1>{get(websiteStats, 'ad.clicks', 0)}</h1></div>
            </div></div>
            <div className="col-md-4 col-lg-3"><div className="ibox">
              <div className="ibox-title">
              <span className="label label-primary pull-right">{this.state.chosenLabel}</span>
              <h5>Ad Conversions</h5></div>
              <div className="ibox-content"><h1>{get(websiteStats, 'ad.conversions', 0)}</h1></div>
            </div></div>
            <div className="col-md-4 col-lg-3"><div className="ibox">
              <div className="ibox-title">
              <span className="label label-primary pull-right">{this.state.chosenLabel}</span>
              <h5>Ad Impressions</h5></div>
              <div className="ibox-content"><h1>{get(websiteStats, 'ad.impressions', 0)}</h1></div>
            </div></div>
            <div className="col-md-4 col-lg-3"><div className="ibox">
              <div className="ibox-title">
              <span className="label label-primary pull-right">{this.state.chosenLabel}</span>
              <h5>Ad ACPC</h5></div>
              <div className="ibox-content"><h1>{get(websiteStats, 'ad.cpc', 0)}</h1></div>
            </div></div>
            <div className="col-md-4 col-lg-3"><div className="ibox">
              <div className="ibox-title">
              <span className="label label-primary pull-right">{this.state.chosenLabel}</span>
              <h5>Ad ACPA</h5></div>
              <div className="ibox-content"><h1>{get(websiteStats, 'ad.cpa', 0)}</h1></div>
            </div></div>
            <div className="col-md-4 col-lg-3"><div className="ibox">
              <div className="ibox-title">
              <span className="label label-primary pull-right">{this.state.chosenLabel}</span>
              <h5>Ad Earnings</h5></div>
              <div className="ibox-content"><h1>{get(websiteStats, 'ad.earnings', 0)}0</h1></div>
            </div></div>
          </div>
          <Popup website={website} />
        </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { ssp: { websiteStats } } = state;
  return { websiteStats: websiteStats.data || {} };
};

export default connect(mapStateToProps)(Dashboard);
